var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1797 22.1523C17.7025 22.1523 22.1797 17.6752 22.1797 12.1523C22.1797 6.6295 17.7025 2.15234 12.1797 2.15234C6.65684 2.15234 2.17969 6.6295 2.17969 12.1523C2.17969 17.6752 6.65684 22.1523 12.1797 22.1523Z",
    stroke: "#714FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26978 9.15291C9.50488 8.48458 9.96893 7.92102 10.5797 7.56205C11.1905 7.20307 11.9087 7.07185 12.607 7.19163C13.3052 7.3114 13.9386 7.67444 14.3949 8.21644C14.8511 8.75844 15.1008 9.44444 15.0998 10.1529C15.0998 12.1529 12.0998 13.1529 12.0998 13.1529",
    stroke: "#714FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1797 17.1523H12.1897",
    stroke: "#714FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqQuestionMark);
export default __webpack_public_path__ + "static/media/FaqQuestionMark.a312c95607949c4ae28dedf41f8ff854.svg";
export { ForwardRef as ReactComponent };